<div class="graph-wrapper">
  <button class="reset-btn" (click)="resetGraph()">Reset Graph</button>
  <button class="center-btn" (click)="centerGraph()">Center Graph</button>
  <div #graphContainer id="graphContainer"></div>
  <div class="project-info-box" *ngIf="selectedProject">
    <button class="close-button" (click)="closeInfoBox()">✖️</button>
    <h3>{{ selectedProject.id }}</h3>
    <div class="scrollable-description">
      <h6>{{ selectedProject.domain }}</h6>
      <h6>{{ selectedProject.techMaturity }}</h6>
      <h6>{{ selectedProject.team }}</h6>
      <h6>{{ selectedProject.STICTeam }}</h6>
      <h6>{{ selectedProject.stakeholders }}</h6>
      <h6>{{ selectedProject.mainConcept }}</h6>
      <h6>{{ selectedProject.subConcept }}</h6>
      {{ selectedProject.description }}
      <br />
      <a [href]="'https://slb001.sharepoint.com/sites/STICRadars/' + selectedProject.path">Visit SharePoint Page</a>
    </div>
  </div>

  <div #graphContainer class="graph-container" style="width: 100%; height: 100%"></div>
</div>
